// extracted by mini-css-extract-plugin
export default {"customButton":"SecondaryButton_customButton__osrZ7"};